import React, { useEffect, useState } from 'react';
import useInterval from './useInterval';
import { usePayDataContext } from '../../contexts/PayDataContext';
import Failed from "./failed";


const Waiting = () => {
  const [showNumber, setShowNumber] = useState(false);
  const [countdown, setCountdown] = useState(300);
  const [countdownFinished, setCountdownFinished] = useState(false); 
  const { accountData } = usePayDataContext();

  const handleShowNumber = () => {
    setShowNumber(!showNumber);
  };

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
  };

  useEffect(() => {
    if (countdown === 0) {
      setCountdownFinished(true);
    }
  }, [countdown]);

  useInterval(() => {
    if (countdown > 0) {
      setCountdown((prevCountdown) => prevCountdown - 1);
    }
  }, 1000);

  return (
    <div>
      {countdownFinished ? (
        <div className="my-4">
          <Failed />
        </div>) : (
        <>
          <p className="text-[var(--Checkout-text-color)] font-bold mb-4 text-sm text-center">
            We’re waiting to confirm your transfer. This can take a few minutes.
          </p>
          <div className="flex justify-center items-center h-32">
            <div className="lds-spinner">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>

          <div className="flex items-center justify-center">
            <button className="px-2 py-[0.4rem] w-64 border border-[#d0d5dd] rounded-xl outline-none my-2 sm:w-[17rem] text-[#667085] text-sm bg-white">
              Please wait for {formatTime(countdown)}
            </button>
          </div>
          <p onClick={handleShowNumber} className="text-center text-sm hover:text-[var(--SarepayPrimary-color)]">
            Show account number
          </p>
          {showNumber && (
            <p className="text-center text-sm font-bold my-1 text-[var(--Checkout-text-color)]">{accountData.account_number}</p>
          )}
        </>
      )}
    </div>
  );
};

export default Waiting;
